<template>
    <div>   
        <div class="page-header">
            <h3>{{ $t('companies') }}</h3>
            <router-link :to="{name : 'admin.companies.create'}" class="btn btn-success">
                <fa :icon="['fal','plus-circle']" /> {{ $t('add_new_company') }}
            </router-link>
        </div>
            
        <grid 
            :data="companies"
            :columns="columns"
            v-on:update-data="fetchData"
            v-on:row-clicked="goToEdit"
            edit-route="/admin/companies"
            delete-route="/api/company"
            with-edit
            with-delete>
        </grid>
    </div>
</template>
<script>
import $ from 'jquery'
import axios from "axios";
import Form from "vform";
import Grid from "~/components/Grid";

export default {
    data() {
        return {
            loading: false,
            companies: null,
            error: null,
            columns: [
                { 'col' : 'name','title' : 'Namn'},
                { 'col' : 'contact_email','title' : 'Kontaktadress'},
                { 'col' : 'users_count','title' : 'Användare'},
                { 'col' : 'created_at', 'title' :'Skapad'},
            ],
        };
    },
    components: {
        Grid
    },
    created() {
        this.fetchData();
    },
    methods: {
        goToEdit(entry){
            this.$router.push("/admin/companies/" + entry.id)
        },
        async fetchData() {
            this.error = this.companies = null;
            this.loading = true;

            const { data } = await axios.get("/api/company");

            this.loading = false;
            this.companies = data;
        },
        async deleteCompany(id) {
            if(confirm(this.$t('delete_company'))){
                const { data } = await this.form.delete("/api/company/" + id);
                this.fetchData();
            }
        }
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/admin/companies/index.vue